module.exports = __webpack_public_path__ + "static/media/unsplash-1.e88d8fe9.jpg";